import { render, staticRenderFns } from "./FigureItem.vue?vue&type=template&id=5048c2c0&scoped=true&"
import script from "./FigureItem.vue?vue&type=script&lang=js&"
export * from "./FigureItem.vue?vue&type=script&lang=js&"
import style0 from "./FigureItem.vue?vue&type=style&index=0&id=5048c2c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5048c2c0",
  null
  
)

export default component.exports